// extracted by mini-css-extract-plugin
module.exports = {"brokenScreen":"PgHyKl"};